import React from 'react';
import PropTypes from 'prop-types';
import {generateId} from '../../utilities'

export const InputField = ({autoComplete, checked, disabled, error, id, label, maxLength, min, max, onBlur, onFocus, onChange, placeholder, step, type, value}) => {
	const getWrapClassName = () => {
		let appendVal = '';
		if (disabled) {
			appendVal = ' disabled';
		} else if (error) {
			appendVal = ' error'
		}
		return `form-element ${id} ${appendVal}`
	}

	const renderInput = () => {
		if (type === 'textarea') {
			return (
				<textarea
					disabled={disabled}
					id={id}
					maxLength={maxLength}
					onBlur={onBlur}
					onChange={onChange}
					onFocus={onFocus}
					placeholder={placeholder}
					value={value}
				/>
			);
		} else if (type === 'number') {
			return (
				<input
					type="number"
					value={`${value === 0 ? '' : value}`}
					step={step}
					min={min}
					max={max}
					id={id}
					onChange={onChange}
					disabled={disabled}
			 	/>
		 	);
	 } else if (type === 'checkbox' && value.length) {
		return value.map(val => {
			const inputId = generateId(val, id);
			const isDisabled = disabled.indexOf(val) >= 0 ? true : false;
			return (
				<div className={`checkbox-input${isDisabled ? ' disabled' : ''}`} key={inputId}>
					<input
						id={inputId}
						type="checkbox"
						onChange={onChange}
						disabled={isDisabled}
						checked={checked.indexOf(val) >= 0 ? true : false}
				 	/>
				<label htmlFor={inputId}>{val}</label>
				</div>
			);
		});
	}
		return (
			<input
				autoComplete={autoComplete || 'off'}
				disabled={disabled}
				id={id}
				onBlur={onBlur}
				onChange={onChange}
				onFocus={onFocus}
				placeholder={placeholder}
				value={value}
			/>
		);
	}

	const getClassName = () => {
		if (type === 'textarea') {
			return 'textarea-wrap';
		} else if (type === 'number') {
			return 'input-wrap small';
		} else if (type === 'checkbox') {
			return 'checkbox-wrap';
		}
		return 'input-wrap'
	}

	return (
		<div className={getWrapClassName()}>
			{ label && <h2><label htmlFor={id}>{label}:</label></h2> }
			<div className={getClassName()}>
				{renderInput()}
			</div>
		</div>
	);
}

InputField.propTypes = {
	disabled: function(props, propName, componentName) {
		const propType = typeof(props[propName]);

		if (props['type'] === 'checkbox' && propType !== 'object') {
		   return new Error(`Checkbox failed prop type: Invalid prop "${propName}" of type ${propType}`);
	   } else if (props['type'] !== 'checkbox' && propType !== 'boolean') {
			return new Error(`Input failed prop type: Invalid prop ${propName} of type ${propType}`);
		}
  	},
	error: PropTypes.string,
	id: PropTypes.string.isRequired,
	label: PropTypes.string,
	onBlur: PropTypes.func,
	onChange: PropTypes.func,
	onFocus: PropTypes.func,
	type: PropTypes.string,
	value: function(props, propName, componentName) {
		const propType = typeof(props[propName]);

		if (props['type'] === 'checkbox' && propType !== 'object') {
		   return new Error(`Checkbox failed prop type: Invalid prop "${propName}" of type ${propType}`);
	    } else if (props['type'] === 'number' && propType !== 'number') {
      		return new Error(`Number input failed prop type: Invalid prop ${propName} of type ${propType}`);
    	} else if (props['type'] !== 'number' &&  props['type'] !== 'checkbox' && propType !== 'string') {
			return new Error(`Input failed prop type: Invalid prop ${propName} of type ${propType}`);
		}
  	}
};

InputField.defaultProps = {
	disabled: false
};

export default InputField;
